import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {TableModule} from "primeng/table";
import {DatePipe} from "@angular/common";
import {MessageService} from "primeng/api";
import {FeedbackService} from "../../services/feedback.service";
import {RatingDto} from "admin-api-dto";

@Component({
  selector: 'app-ratings-tab',
  standalone: true,
  imports: [TableModule, DatePipe],
  templateUrl: './ratings-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingsTabComponent {
  private readonly feedbackService = inject(FeedbackService);
  private readonly messageService = inject(MessageService);

  protected readonly items = signal<RatingDto[]>([]);
  protected readonly loading = signal(true);

  constructor() {
    this.feedbackService.getRatings().subscribe({
      next: items => {
        this.items.set(items);
        this.loading.set(false);
      },
      error: () => {
        this.loading.set(false);
        this.messageService.add({severity: 'error', summary: 'Failed to load ratings'});
      }
    });
  }
}
